import { Link } from "react-router-dom";

interface RevealCardProps {
  title: string;
  category: string;
  imageUrl: string;
  time: string;
  hot: number;
  articleSlug?: string;
  categorySlug?: string;
}

export default function RevealCard({ title, category, imageUrl, time, hot, articleSlug, categorySlug }: RevealCardProps) {
  const linkTo = '/';

  return (
    <Link
      to={linkTo}
      className="group block rounded-lg overflow-hidden relative aspect-[4/5] bg-background-100 cursor-pointer"
    >
      <img
        src={imageUrl}
        alt={title}
        title={title}
        className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>

      <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500 text-white whitespace-nowrap">
        {category}
      </span>

      <div className="absolute bottom-0 left-0 right-0 p-4">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs text-white/70">{time}</span>
          <span className="text-xs text-accent-300 flex items-center gap-0.5">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-fire-line text-xs"></i>
            </div>
            {(hot / 10000).toFixed(1)}万热
          </span>
        </div>
        <h3 className="text-sm md:text-base font-semibold text-white leading-snug line-clamp-2">
          {title}
        </h3>
      </div>
    </Link>
  );
}